import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import CheckboxGroup from '@/components/CheckboxGroup.js';
import {
  ALL_TABLE_TYPES,
  ISARCHIVE_TYPES,
  MODAL_TYPES,
  ORDER_STATUS_TYPES,
  ROLE_TYPES,
} from '@/constants/constants.js';
import { flowTypesOptions } from '@/constants/dropdownOptions.js';
import CustomModal from '@/components/CustomModal.js';
import {
  assignStaff,
  getActiveStaffData,
} from '@/features/systemManagement/account/accountService.js';
import { updateFileFieldValue } from '@/features/orders/ordering/services/orderMediaService.js';
import { deleteOrder } from '@/features/orders/ordering/services/orderService.js';
import SelectInput from '@/components/SelectInput.js';
import LoadingIndicator from '@/components/LoadingIndicator.js';

import './OrderModal.scss';
import { handleApiRequest } from '../AdminTaskAction/AdminTaskAction.js';
import { useNavigate, useSearchParams } from 'react-router-dom';

dayjs.extend(utc);

export const OrderModal = ({
  visible,
  confirmText,
  setConfirmText,
  modalType,
  setModalType,
  //operationPage
  role,
  formik_AiTexts,
  flow_type,
  setFlow_type,
  handleCloseModal,
  useAiText,
  user_id,
  updateTaskStatus,
  startWorkflow,
  workingOrder,
  fetchData,
  selectedOrder,
  formik_CreateOrder,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [staffData, setStaffData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [confirmBtnDisabled, setConfirmBtnDisabled] = useState(false);
  const pageNumber = searchParams.get('page');
  
  const statusText =
    selectedOrder && selectedOrder.status
      ? Object.keys(ORDER_STATUS_TYPES).find(
          (key) => ORDER_STATUS_TYPES[key] === selectedOrder.status
        )
      : null;

  const fetchStaffData = async () => {
    try {
      const response = await getActiveStaffData(ROLE_TYPES.制作人员);
      setConfirmBtnDisabled(true);
      setStaffData(response);
      const selectedId = selectedOrder.assigned_staff.assigned_staff_id;
      const selectedStaffObj = response.find(
        (staff) => staff.id === selectedId
      );
      setSelectedStaff(selectedStaffObj || []);
      setIsLoading(false);
    } catch (error) {
      console.error('获取人员数据失败:', error);
      return []; // 返回空数组或处理错误
    }
  };

  useEffect(() => {
    if (modalType === MODAL_TYPES.人员分配) {
      fetchStaffData();
    } else {
      setConfirmBtnDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalType, selectedOrder]);

  const handleSelectStaff = (value) => {
    const selectedId = value;
    const selectedStaffObj = staffData.find((staff) => staff.id === selectedId);
    setSelectedStaff(selectedStaffObj);
    setConfirmBtnDisabled(false);
  };

  const getModalBodyContent = () => {
    switch (modalType) {
      case MODAL_TYPES.请再次确认文案:
      case MODAL_TYPES.管理员修改文案:
        return (
          <div className="text-confirm-container">
            {role === ROLE_TYPES.管理员
              ? '修改后文案：'
              : '以下为最终视频文案：'}
            <div className="text-container">
              <strong>致辞：</strong>
              {useAiText
                ? formik_AiTexts.values.speech_text
                  ? formik_AiTexts.values.speech_text
                  : '无告别文案'
                : formik_AiTexts.values.custom_speech_text}
            </div>
            <div className="text-container">
              <strong>告别：</strong>
              {useAiText
                ? formik_AiTexts.values.farewell_text
                  ? formik_AiTexts.values.farewell_text
                  : '无告别文案'
                : formik_AiTexts.values.custom_farewell_text}
            </div>
            <div className="alert-container">
              <div className="alert alert-danger">
                {role === ROLE_TYPES.管理员
                  ? '请确认文案无误后提交'
                  : '请确认以上文案无误后提交，提交后将无法修改。'}
              </div>
            </div>
          </div>
        );
      case MODAL_TYPES.请选择自动化流程:
        return (
          <div className="text-confirm-container">
            <CheckboxGroup
              name="videoType"
              options={flowTypesOptions}
              value={flow_type}
              onChange={(value) => {
                setFlow_type(value);
              }}
              className="col-md-12"
            />
          </div>
        );
      case MODAL_TYPES.订单创建失败:
        return (
          <div className="text-confirm-container">
            创建新订单失败，请稍后重新确认下单
          </div>
        );
      case MODAL_TYPES.订单提交失败:
        return (
          <div className="text-confirm-container">
            提交订单失败，请稍后重新确认提交
          </div>
        );
      case MODAL_TYPES.验证失败:
        return (
          <div className="text-confirm-container">
            <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
              {window.formValidationErrorMessage ||
                '表单验证失败，请检查输入内容'}
            </div>
          </div>
        );
      case MODAL_TYPES.确认完结订单:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-warning ">
              当前订单状态为：{statusText}。 确认完结该订单？
            </div>
          </div>
        );
      case MODAL_TYPES.确认删除订单:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-danger ">确认删除该订单？</div>
          </div>
        );
      case MODAL_TYPES.存在正在进行的工作流:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-warning ">
              {`订单:${workingOrder.clientName} (订单id: ${workingOrder.client_id}) 正在执行工作流`}
            </div>
          </div>
        );
      case MODAL_TYPES.人员分配:
        return isLoading ? (
          <LoadingIndicator />
        ) : (
          <div className="assign-staff-container">
            <div className="video-info-container">
              <div className="video-info-header">视频信息</div>
              <div className="video-info-detail">
                <strong>客户姓名：{selectedOrder.clientName}</strong>
                <br />
                <strong>仪式时间：{selectedOrder.ceremonyDate}</strong>
                <br />
                <strong>视频标准: {selectedOrder.videoType}</strong>
              </div>
            </div>
            <div className="staff-container">
              <div className="staff-header">分配人员</div>
              <div className="assigned-staff-detail">
                <SelectInput
                  name="videoType"
                  options={staffData.map((staff) => ({
                    value: staff.id,
                    label: staff.companyName,
                  }))}
                  onChange={(e) => {
                    handleSelectStaff(e.target.value);
                  }}
                  className="col-md-12"
                  defaultValue={selectedOrder.assigned_staff.assigned_staff_id}
                />
                <div className="selected-staff-info">
                  {selectedStaff && selectedStaff.id ? (
                    <>
                      <p>
                        分配总单数单量: {selectedStaff.assignment_count || 0} 单
                      </p>
                      {selectedStaff.文案确认中 &&
                        Number(selectedStaff.文案确认中) !== 0 && (
                          <p>文案确认中的单量: {selectedStaff.文案确认中} 单</p>
                        )}
                      {selectedStaff.视频制作中 &&
                        Number(selectedStaff.视频制作中) !== 0 && (
                          <p>视频制作中的单量: {selectedStaff.视频制作中} 单</p>
                        )}
                      {selectedStaff.审核中 &&
                        Number(selectedStaff.审核中) !== 0 && (
                          <p>审核中的单量: {selectedStaff.审核中} 单</p>
                        )}
                      {selectedStaff.资料修改中 &&
                        Number(selectedStaff.资料修改中) !== 0 && (
                          <p>资料修改中的单量: {selectedStaff.资料修改中} 单</p>
                        )}
                      {selectedStaff.已完成 &&
                        Number(selectedStaff.已完成) !== 0 && (
                          <p>已完成的单量: {selectedStaff.已完成} 单</p>
                        )}
                      {selectedStaff.未提交 &&
                        Number(selectedStaff.未提交) !== 0 && (
                          <p>未提交的单量: {selectedStaff.未提交} 单</p>
                        )}
                    </>
                  ) : (
                    <p>未选择</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case MODAL_TYPES.确认审核通过:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-warning ">确认审核通过该订单？</div>
          </div>
        );
      case MODAL_TYPES.确认审核不通过:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-warning ">确认该订单审核不通过？</div>
          </div>
        );
      case MODAL_TYPES.无权限:
        return (
          <div className="text-confirm-container">
            <div className="alert alert-warning ">
              订单地址已更新，您当前没有权限访问该地址。系统将自动跳转至订单列表页面，请您从订单列表中选择并访问该订单。
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const handleConfirmBtn = async () => {
    let shouldCloseModal = true;
    switch (modalType) {
      case MODAL_TYPES.请再次确认文案:
        formik_AiTexts.submitForm();
        break;
      case MODAL_TYPES.管理员修改文案:
        formik_AiTexts.submitForm();
        break;
      case MODAL_TYPES.订单创建失败:
        formik_CreateOrder.setStatus({});
        formik_CreateOrder.setErrors({});
        break;
      case MODAL_TYPES.验证失败:
        // 清理错误信息
        window.formValidationErrorMessage = null;
        break;
      case MODAL_TYPES.确认完结订单:
        handleCloseOrder();

        break;
      case MODAL_TYPES.存在正在进行的工作流:
        handleStartBtnClick(selectedOrder.client_id);
        break;
      case MODAL_TYPES.请选择自动化流程:
        handleStartFlow(flow_type);
        break;
      case MODAL_TYPES.确认删除订单:
        await handleDeleteOrder(selectedOrder.client_id, ISARCHIVE_TYPES.归档);
        fetchData();
        break;
      case MODAL_TYPES.确认审核通过:
        setModalType(MODAL_TYPES.人员分配);
        setConfirmText('确定分配');
        shouldCloseModal = false;
        await handleApiRequest(
          selectedOrder.client_id || selectedOrder.client_id,
          ORDER_STATUS_TYPES.工作流待开始
        );
        break;
      case MODAL_TYPES.确认审核不通过:
        try {
          await handleApiRequest(
            selectedOrder.client_id || selectedOrder.client_id,
            ORDER_STATUS_TYPES.资料修改中
          );
          if (fetchData) {
            fetchData();
          } else {
            navigate(`/clients`);
          }
        } catch (error) {
          console.error('审核不通过操作失败', error);
        }
        break;
      case MODAL_TYPES.人员分配:
        await assignStaff(
          selectedOrder.client_id || selectedOrder.client_id,
          'assigned_staff_id',
          selectedStaff ? selectedStaff.id : null
        );
        if (fetchData) {
          fetchData();
        }
        if (pageNumber) {
          navigate(`/clients?page=${pageNumber}`);
        } else {
          navigate(`/clients`);
        }
        break;
      case MODAL_TYPES.无权限:
        navigate('/clients');
        break;
      default:
        break;
    }
    if (shouldCloseModal) {
      handleCloseModal();
    }
  };

  const handleStartBtnClick = (client_id) => {
    const encodedClientId = encodeURIComponent(client_id);
    navigate(`/startWorkFlow/true/${encodedClientId}`);
  };

  const handleDeleteOrder = async (client_id, isDelete) => {
    try {
      const response = await deleteOrder(client_id, isDelete);
      if (fetchData) {
        fetchData();
      }
      return response.data;
    } catch (error) {
      console.error('删除订单失败', error);
    }
  };

  const handleStartFlow = async (flow_type) => {
    try {
      await updateTaskStatus(
        selectedOrder.client_id,
        ORDER_STATUS_TYPES.工作流进行中
      );
      startWorkflow(selectedOrder.client_id, user_id, flow_type, true);
      navigate(`/clients`);
    } catch (error) {
      console.error('启动工作流失败:', error);
    }
  };

  const handleCloseOrder = async () => {
    try {
      await handleApiRequest(
        selectedOrder.client_id,
        ORDER_STATUS_TYPES.已完成
      );
      
      await updateFileFieldValue(
        ALL_TABLE_TYPES.clients,
        'complted_time',
        selectedOrder.client_id,
        dayjs().format('YYYY-MM-DD HH:mm:ss')
      );
      
      if (fetchData) {
        fetchData();
      }
      if (!fetchData) {
        setTimeout(() => {
          navigate(`/clients`);
        }, 500);
      }
    } catch (error) {
      console.error('完结工作流失败:', error);
    }
  };

  return (
    <CustomModal
      show={visible}
      onHide={handleCloseModal}
      title={modalType}
      body={getModalBodyContent()}
      confirmText={confirmText}
      cancelText="取消"
      onConfirm={handleConfirmBtn}
      onCancel={handleCloseModal}
      confirmBtnDisabled={confirmBtnDisabled}
    />
  );
};

export default OrderModal;
